// extracted by mini-css-extract-plugin
export default {"content":"CompleteStep_content__oum4L","illustration":"CompleteStep_illustration__xWgb3","action":"CompleteStep_action__RDmMY","button":"CompleteStep_button__LUcQN"};